import { Search, SlidersHorizontal, ArrowUpDown } from 'lucide-react'
import { USER_PROFILE_OPTIONS } from '@services/userManagementService'

export default function UserFilters({ filters, searchValue, onSearchChange, onFilterChange }) {
  return (
    <section className="users-filter-card" aria-label="Filtros de usuários">
      <div className="users-filter-search">
        <label className="users-field-label" htmlFor="user-search">
          Buscar por nome ou email
        </label>
        <div className="users-input-with-icon">
          <Search size={18} />
          <input
            id="user-search"
            className="users-text-input"
            type="search"
            placeholder="Ex.: Mariana Veiga"
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value)}
          />
        </div>
      </div>
    </section>
  )
}
